import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Directory } from 'src/app/interfaces/directory';
import { UserMessage } from 'src/app/interfaces/user-message';
import { DirectoryService } from 'src/app/services/api/directory.service';
import { MessageService } from 'src/app/services/api/message.service';
import { SharedDirectoryToSendService } from 'src/app/services/shared/shared-directory-to-send.service';
import { PatientInfoEditComponent } from '../patient-info-edit/patient-info-edit.component';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-patient-info-modal',
  templateUrl: './patient-info-modal.component.html',
  styleUrls: ['./patient-info-modal.component.scss'],
})
export class PatientInfoModalComponent implements OnInit {
  @Input() patientID!: string;

  public patient!: Directory;

  public errorMessage: string = '';
  public errorType: string = '';

  public lastMessages: MatTableDataSource<UserMessage> | undefined;
  selection = new SelectionModel<UserMessage>(true, []);
  disableReplayAll = true;

  displayedColumns: string[] = [
    'recipient',
    'objet',
    'date',
    'attachments',
    'action',
  ];

  constructor(
    public activeModal: NgbActiveModal,
    public route: Router,
    public directoryService: DirectoryService,
    public messageService: MessageService,
    private sharedDirectoryToSendService: SharedDirectoryToSendService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    // On récupère le patient dont on veut les infos
    this.directoryService.getPatient(this.patientID).subscribe(
      (res) => {
        if (res.result == 'SUCCESS') {
          this.patient = res.content;
          // Récupérer les 5 derniers messages non ouverts su patient
          this.lastMessages = new MatTableDataSource(this.patient.lastMessage);
          if (this.patient.lastMessage) {
            this.disableReplayAll = this.patient.lastMessage.find(
              (message) => {
                return this.isWithinLastThreeMonths(
                  message.messages.date_envoi
                );
              }
            )
              ? false
              : true;
          }
        } else {
          this.errorMessage = res.content;
          this.errorType = res.result;
          //this.modalService.dismissAll("Delete " + patient.user.email);
        }
      },
      (err) => {
        this.modalService.dismissAll('Delete ' + this.patientID);
      }
    );
  }

  private parseDate(dateString: string): Date | null {
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart
      .split('/')
      .map((part) => parseInt(part, 10));
    const [hours, minutes, seconds] = timePart
      .split(':')
      .map((part) => parseInt(part, 10));

    if (
      isNaN(day) ||
      isNaN(month) ||
      isNaN(year) ||
      isNaN(hours) ||
      isNaN(minutes) ||
      isNaN(seconds)
    ) {
      return null;
    }

    return new Date(year, month - 1, day, hours, minutes, seconds);
  }
  public isWithinLastThreeMonths(dateString: string): boolean {
    const dateEnvoi = this.parseDate(dateString);
    const currentDate = new Date();
    const differenceInMilliseconds =
      currentDate.getTime() - dateEnvoi!.getTime();
    const differenceInDays = differenceInMilliseconds / (1000 * 3600 * 24);
    return differenceInDays <= 90;
  }

  public updatePatientInfo(patient: Directory) {
    const modalRef = this.modalService.open(PatientInfoEditComponent);
    modalRef.componentInstance.patient = patient;
    modalRef.result.then(
      (data) => {},
      (reason) => {
        if (reason != 0) {
          this.patient = reason;
        }
      }
    );
  }

  public replayMessages(patient: Directory) {
    this.messageService.reSendByPatient(patient.user.id).subscribe((res) => {
      this.errorMessage = res.content;
      this.errorType = res.result;
    });
  }

  public replayMessage(message: UserMessage) {
    this.messageService.reSend(message.id).subscribe((res) => {
      this.errorMessage = res.content;
      this.errorType = res.result;
    });
  }

  public writeMessage(patient: Directory) {
    const dest = { email: patient.user.email, directory: patient.uuid };
    this.sharedDirectoryToSendService.addDirectory(dest);
    /*this.route.navigate(['/create'], {
      queryParams: { recipient: patient.user.email },
    });*/
    this.activeModal.dismiss('Add ' + patient.user.email);
  }

  public removePatient(patient: Directory) {
    if (
      confirm(
        'Voulez-vous retirer le patient (' +
          patient.lname +
          ' ' +
          patient.fname +
          ') de votre carnet ?'
      )
    ) {
      this.directoryService.removePatient(patient.user.id).subscribe((res) => {
        this.errorMessage = res.content;
        this.errorType = res.result;
        this.modalService.dismissAll('Delete ' + patient.user.email);
      });
    }
  }

  open(row: any) {
    this.modalService.dismissAll();
    this.route.navigate(['/open', row.role1_ref]);
  }
}
